import React, { useState, useEffect } from "react";
import 'react-quill/dist/quill.snow.css';
import GlobalStyles from 'styles/GlobalStyles';
import SignUp from './components/Signup.js';
import Login from './components/Login.js';
import RestaurantLandingPage from './components/RestaurantLandingPage.js';
import TermsOfService from './components/TermsOfService.js';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Boutique from "components/Boutique.js";
import './Boutique.css';
import './ProductDetails.css';
import './Checkout.css';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ProductDetails from "components/ProductDetails.js";
import CheckoutFrom from "components/CheckoutForm.js";
import ForgotPassword from "components/ForgotPassword.js";
import ResetPassword from "components/ResetPassword.js";
import Orders from "components/Admin/Orders.jsx";
import Profile from "components/Admin/Profile.js";
import Point from "components/Admin/points.jsx";
import OrdersAdmin from "components/AdminDashbord/Orders.jsx";
import OrdersSans from "components/AdminDashbord/OrdersSans.jsx";


import OrderLP from "components/AdminDashbord/OrderLpAdmin.js";
import ProduitsAdmin from "components/AdminDashbord/Produits.jsx";
import DashbordAdmin from "components/AdminDashbord/Dashbord.jsx";
import PaymentAdmin from "components/AdminDashbord/Payment.jsx";
import UserAdmin from "components/AdminDashbord/UserAdmin.jsx";
import DisInfUsers from "components/AdminDashbord/DisInfUsers.jsx";
import ClientUsers from "components/AdminDashbord/ClientUsers.jsx";

import ClientAdmin from "components/AdminDashbord/ClientAdmin.jsx";
import Retraite from "components/AdminDashbord/Retraite.jsx";
import ProtectedRoute from "./ProtectedRoute"; // Import ProtectedRoute component
import Contact from "Contact.js";
import AboutLadyCosmeticos from "components/propos.jsx";
import Cosmetique from './components/cards/Cosmetique.js';
import Complements from './components/cards/Complement.js';
import Packs from './components/cards/Packs.js';
import LanguageSwitcher from "components/LanguageSwitcher.jsx";
import i18n from "./i18n"; // adjust path if needed
import Champoing from "components/cards/Champoing.jsx";
import Garence from "components/cards/Garence.jsx";
import AdminAnnouncement from "components/AdminDashbord/AdminAnnouncement.jsx";
import OrderSalesAdmin from "components/AdminDashbord/OrderSalesAdmin.jsx";
import ProductSalesAdmin from "components/AdminDashbord/ProductSalesAdmin.jsx";
import AnnouncementBanner from "components/AnnouncementBanner.jsx";
import WhatsAppButton from "components/WhatsAppButton.jsx";
import ScrollToTop from "components/ScrollToTop.jsx";
import Catalogue from "components/Catalogue.jsx";
import BlogPage from "./components/BlogPage";
import BlogDetail from "./components/BlogDetail"
export default function App() {
  const [role, setRole] = useState(null);
   useEffect(() => {
    const currentLang = i18n.language;
    const dir = currentLang === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", currentLang);
  }, [i18n.language]);
  useEffect(() => {
    const storedRole = localStorage.getItem('isAdmin'); 
    if (storedRole !== null) {
      setRole(storedRole);
    } else {
      setRole(''); 
    }
  }, []);
  if (role === null) {
    return <div>Loading...</div>;
  }
  
  return (
    <>
     <LanguageSwitcher />

      <GlobalStyles />
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<RestaurantLandingPage />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/contact" element={<Contact/>} />
          <Route path="/Boutique" element={<Boutique/>} />
          <Route path="/à-props" element={<AboutLadyCosmeticos/>} />
          <Route path="/Cosmetique" element={<Cosmetique/>} />
          <Route path="/Complements" element={<Complements/>} />
          <Route path="/Packs" element={<Packs/>} />
          <Route path="/Shampoing-1l" element={<Champoing/>} />
          <Route path="/Garence" element={<Garence/>} />
          <Route path="/catalogue" element={<Catalogue/>} />
          <Route path="/banner" element={<AnnouncementBanner/>} />
<Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/point" element={<Point />} />

          <Route
            path="/product-details/:id"
            element={
                <ProductDetails />
            }
          />
<Route
            path="/checkout"
            element={
                <CheckoutFrom />
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedRoles={['0']}>
                <Orders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute allowedRoles={['0']}>
                <Profile />
              </ProtectedRoute>
            }
          />

          {/* Admin-only routes */}
          <Route
            path="/dashbord-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <DashbordAdmin />
              </ProtectedRoute>
            }
          />

          <Route
            path="/OrderLP"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <OrderLP />
              </ProtectedRoute>
            }
          />


                  <Route
            path="/admin-announcement"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <AdminAnnouncement/>
              </ProtectedRoute>
            }
          />
<Route
            path="/sales-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <ProductSalesAdmin />
              </ProtectedRoute>
            }
          />
<Route
            path="/orderAdmin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <OrderSalesAdmin/>
              </ProtectedRoute>
            }
          />


          <Route
            path="/order-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <OrdersAdmin />
              </ProtectedRoute>
            }
          />
 <Route
            path="/orderSans"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <OrdersSans />
              </ProtectedRoute>
            }
          />

          <Route
            path="/produits-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <ProduitsAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <PaymentAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <UserAdmin />
              </ProtectedRoute>
            }
          />
 <Route
            path="/DisInfUsers-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <DisInfUsers/>
              </ProtectedRoute>
            }
          />
 <Route
            path="/ClientUsers-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <ClientUsers/>
              </ProtectedRoute>
            }
          />


          <Route
            path="/client-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <ClientAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/retraite"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <Retraite />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
      <WhatsAppButton />

    </>
  );
}